import styled from 'styled-components'
import { media, colors } from 'styles'
import Button from 'components/Button/StyledButton'

const StyledFilter = styled.div`
  position: relative;
  margin: 0.5rem 1rem 0.5rem 0;
  white-space: nowrap;

  ${Button} {
    padding: 0.4rem 0.8rem;
    font-size: 1.2rem;
    font-weight: 600;
    min-width: 5rem; /* makes vip/gold be same width on 2 rows */
    opacity: ${p => (p.active ? '1' : '0.6')};
  }

  &:hover {
    ${Button} {
      opacity: 1;
    }

    .deactivate {
      visibility: visible;
    }
  }

  .deactivate {
    visibility: hidden;
    width: 1rem;
    height: 1rem;
    border: 0.2rem solid ${colors.mainBackground};
    background: url(${() => require('assets/icons/icon_x_rounded.svg')});
    background-size: 0.6rem;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 100%;
    position: absolute;
    top: -0.8rem;
    background-color: ${colors.highlight};
    padding: 0.2rem;
    right: -0.8rem;
  }

  ${media.mobile`
    margin: 0.8rem 1rem 0;

    ${Button} {
      padding: 0.6rem 1.2rem;
      font-size: 1.6rem;
    }

    .deactivate {
      display: none;
      width: 2rem;
      height: 2rem;
      top: -1.2rem;
      right: -1rem;
      border-width: 0.2rem;
    }
  `}
`

const StyledFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export default StyledFilters
export { StyledFilter }
